module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_30-075aedb8a6a287678368f8be5af3549f.png";